import { connect } from "react-redux";
import { relativeDef } from "@skbkontur/staff-common";

import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { withViewModelSelect } from "../../../../Controls/withViewModelSelect";
import { ViewModelSelect } from "../../../../Helpers/StateAccessors/ViewModelSelect";
import { CandyDispatch } from "../../../../Engine/Core/Store/CandyReduxTypes";
import { FormActionHandler } from "../../../../Controls/Internals/FormActionHandlers/FormActionHandler";
import {
    FormActionHandlerExecutionInjectableProps,
    withFormActionHandlerExecution,
} from "../../../../Controls/Internals/FormActionHandlers/WithFormActionHandlerExecution";
import { importRelatives } from "../../State/EmployeeRelativesActionCreators";
import { EmployeeRelativesActionType } from "../../State/EmployeeRelativesAction";
import { PathResolver, withResolvePaths } from "../../../../Controls/withResolvePaths";
import { AbsoluteResolvedModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { BindingPath } from "../../../../Engine/Core/CoreTypes";
import { formatFilterQuery } from "../../../StaffServiceHelpers";
import { isNullOrWhiteSpace } from "../../../../../../Common/TypingUtils";

import { RelativesComboBox } from "./RelativesComboBox";

export interface RelativesComboBoxContainerProps extends FormActionHandlerExecutionInjectableProps {
    bindingPath: AbsoluteResolvedModelPath;
    viewModelSelect: ViewModelSelect;
    resolvePath: PathResolver;
    employeeIdPath?: BindingPath;
    selectedLastNamePath?: BindingPath;
    selectedFirstNamePath?: BindingPath;
    selectedMiddleNamePath?: BindingPath;
    onAdd?: FormActionHandler;
    onSelect?: FormActionHandler;
    queryFilter?: string;
}

const mapStateToProps = (state: FullFormState, ownProps: RelativesComboBoxContainerProps) => ({
    relatives: state.employeeRelatives?.[ownProps.bindingPath.toLegacyPath()]?.relatives ?? [],
    selectedRelative: state.employeeRelatives?.[ownProps.bindingPath.toLegacyPath()]?.selectedRelative,
    isReadOnly: state.settings.isReadOnly,
    employeeId: ownProps.employeeIdPath
        ? ownProps.viewModelSelect.controlModel(state, ownProps.resolvePath(ownProps.employeeIdPath) ?? "").value
        : undefined,
    selectedLastName: ownProps.selectedLastNamePath
        ? ownProps.viewModelSelect.controlModel(state, ownProps.resolvePath(ownProps.selectedLastNamePath) ?? "").value
        : undefined,
    selectedFirstName: ownProps.selectedFirstNamePath
        ? ownProps.viewModelSelect.controlModel(state, ownProps.resolvePath(ownProps.selectedFirstNamePath) ?? "").value
        : undefined,
    selectedMiddleName: ownProps.selectedMiddleNamePath
        ? ownProps.viewModelSelect.controlModel(state, ownProps.resolvePath(ownProps.selectedMiddleNamePath) ?? "")
              .value
        : undefined,
});

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: RelativesComboBoxContainerProps) => ({
    getRelatives: async () =>
        await dispatch(
            importRelatives(
                ownProps.viewModelSelect,
                ownProps.bindingPath,
                ownProps.employeeIdPath ? ownProps.resolvePath(ownProps.employeeIdPath) : undefined,
                {
                    filter: !isNullOrWhiteSpace(ownProps.queryFilter)
                        ? formatFilterQuery(ownProps.queryFilter)
                        : undefined,
                }
            )
        ),
    onAdd: async (query: string) => {
        if (ownProps.onAdd != undefined) {
            await ownProps.executeFormActionHandler(ownProps.onAdd, query);
        }
    },
    onSelect: async (value: relativeDef) => {
        dispatch({
            type: EmployeeRelativesActionType.SelectRelative,
            payload: {
                path: ownProps.bindingPath.toLegacyPath(),
                relative: value,
            },
        });
        if (ownProps.onSelect != undefined) {
            await ownProps.executeFormActionHandler(ownProps.onSelect, value);
        }
    },
});

export const RelativesComboBoxContainer = withResolvePaths(
    withFormActionHandlerExecution(withViewModelSelect(connect(mapStateToProps, mapDispatchToProps)(RelativesComboBox)))
);
